/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import { JsonFormsRendererRegistryEntry } from "@jsonforms/core";
import styled from "styled-components";
import { colourStaticGrey, colourNeutral3 } from "@ingka/variables/colours-css";
import { Properties } from "./Properties";
import { Tooltip } from "@mui/material";
import Button from "@ingka/button";
import arrowLeftToLineSmall from "@ingka/ssr-icon/paths/arrow-left-to-line-small";
import arrowRightToLineSmall from "@ingka/ssr-icon/paths/arrow-right-to-line-small";
import Text from "@ingka/text";

export interface PropertiesPanelProps {
	propertyRenderers: JsonFormsRendererRegistryEntry[];
	hidePropertiesPanel: boolean;
	setHidePropertiesPanel: (hidePropertiesPanel: boolean) => void;
}

const HeadingWrapper = styled.div`
	display: flex;
	padding-left: 1rem;
	padding-right: 0.5rem;
	margin-bottom: 0.5rem;
	border-bottom: 1px solid ${colourStaticGrey};
	justify-content: space-between;
	align-items: center;
`;

const PropertiesWrapper = styled.div`
	margin: 0 1rem 0 1rem;
`;

export const PropertiesPanel: React.FC<PropertiesPanelProps> = ({
	propertyRenderers,
	hidePropertiesPanel,
	setHidePropertiesPanel,
}) => {
	const propertiesPanelText = hidePropertiesPanel ? "Show Properties Panel" : "Hide Properties Panel";
	const propertiesPanelIcon = hidePropertiesPanel ? arrowLeftToLineSmall : arrowRightToLineSmall;

	return (
		<>
			<HeadingWrapper>
				{!hidePropertiesPanel && (
					<Text textStyle="Heading.S" tagName="h2" data-testid="headerPropertiesPanel">
						Properties
					</Text>
				)}

				<div
					style={{
						borderLeft: hidePropertiesPanel ? "none" : `1px solid ${colourNeutral3}`,
					}}
				>
					<Tooltip
						title={propertiesPanelText}
						slotProps={{
							popper: {
								container: document.getElementById("main"),
							},
						}}
					>
						<Button
							data-testid="buttonResizePropertiesPanel"
							iconOnly
							size="small"
							type="tertiary"
							text={propertiesPanelText}
							onClick={() => setHidePropertiesPanel(!hidePropertiesPanel)}
							ssrIcon={propertiesPanelIcon}
							style={{
								marginLeft: "0.5rem",
								...(hidePropertiesPanel
									? {
											position: "absolute",
											top: "0.5rem",
									  }
									: {}),
							}}
						/>
					</Tooltip>
				</div>
			</HeadingWrapper>

			{!hidePropertiesPanel && (
				<PropertiesWrapper>
					<Properties propertyRenderers={propertyRenderers} />
				</PropertiesWrapper>
			)}
		</>
	);
};
